import type { StyleRule } from '@archipro-design/aria';

export const transitionModuleImage = { transition: 'all 0.3s ease-in-out' };

export const RichTextWrapper: StyleRule = ({ theme }) => ({
    width: '100%',
    [theme.screen.laptop]: {
        ...transitionModuleImage,
    },
});
